import type { SinglePagePdf } from "../../files/cached/SinglePagePdf"
import type { TaskName } from "../TaskName"

export type TaskPage = {
  readonly enum: TaskName.CONTENT_PAGED
  readonly content: SinglePagePdf
  readonly page_number: number
  readonly page_count: number
}
